import { render } from "./BabeOrderModal.vue?vue&type=template&id=eb83cfaa&scoped=true&ts=true"
import script from "./BabeOrderModal.vue?vue&type=script&lang=ts"
export * from "./BabeOrderModal.vue?vue&type=script&lang=ts"

import "./BabeOrderModal.vue?vue&type=style&index=0&id=eb83cfaa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb83cfaa"]])

export default __exports__